import { GenericConfig } from "../GenericConfig";

export class Common {
	/**
	 * @param actionName e.g. DepartureBoard.
	 * @returns an URL for the given REST action
	 *          
	 */
	public static getVAOActionUrl(actionName: string) {
		return this.getActionUrl(GenericConfig.getVAOBaseUrl(), actionName);
	}
		/**
	 * @param actionName e.g. OOEVV/TrackRequest.
	 * @returns an URL for the given REST action
	 *          (e.g. https://service_newsrodeo.emmgt.at/V35/RESTService/api/DepartureBoard).
	 */
	public static getNRActionUrl(actionName:string){
		return this.getActionUrl(GenericConfig.getNRBaseUrl(), actionName);
	}
	
	public static getActionUrl(baseUrl:string, actionName:string){
		return encodeURI(baseUrl + actionName);
	}
}